import { uniqid } from "./utils";
import axios from "axios";

export const TrialApi = {
  submitClientDetails(UserData) {
    let API_URL = process.env.VUE_APP_API_URL + "submit-form";
    axios(API_URL, {
      method: "POST",
      data: UserData,
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        this.response = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  submitContactForm(UserData) {
    let API_URL = process.env.VUE_APP_API_URL + "contact";
    axios(API_URL, {
      method: "POST",
      data: UserData,
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        this.response = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
